<template>
  <ul class="float_ad d-grid list-unstyled mb-0 position-fixed">
    <li v-if="banners[9] !== undefined" v-show="show_banner_1">
      <div class="position-relative">
        <div class="d-flex justify-content-end mb-5">
          <button class="btn btn_close p-0 border-0 bg-transparent" type="button" @click="show_banner_1=false">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
              <rect width="12.856" height="1.286" rx="0.643" transform="translate(0.909 0) rotate(45)" fill="#afafaf" />
              <rect width="12.856" height="1.286" rx="0.643" transform="translate(10 0.909) rotate(135)" fill="#afafaf" />
            </svg>
          </button>
        </div>
        <a class="d-block" :href="banners[9].link" :target="banners[9].open_type">
          <img class="mw-100" :src="banners[9].image" width="150" height="150" alt="">
        </a>
      </div>
    </li>
    <li v-if="banners[10] !== undefined" v-show="show_banner_2">
      <div class="position-relative">
        <div class="d-flex justify-content-end mb-5">
          <button class="btn btn_close p-0 border-0 bg-transparent" type="button" @click="show_banner_2=false">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
              <rect width="12.856" height="1.286" rx="0.643" transform="translate(0.909 0) rotate(45)" fill="#afafaf" />
              <rect width="12.856" height="1.286" rx="0.643" transform="translate(10 0.909) rotate(135)" fill="#afafaf" />
            </svg>
          </button>
        </div>
        <a class="d-block" :href="banners[10].link" :target="banners[10].open_type">
          <img class="mw-100" :src="banners[10].image" width="150" height="150" alt="">
        </a>
      </div>
    </li>
    <!--    <a v-if="banners[0] !== undefined" class="d-block" :href="banners[0].link">-->
    <!--      <img class="mw-100" :src="banners[0].image" alt=""> -->
    <!--    </a>-->
  </ul>
</template>

<script>
export default {
  props: {
    banners: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      show_banner_1: true,
      show_banner_2: true
    }
  }
}
</script>

<style>
/* .modal-open .float_ad {
  right: 95px;
} */
</style>
